import React, { useState } from 'react';
// @ts-ignore: allow importing SCSS without type declarations
import './styles.scss';
import { Text } from '../text/Text.tsx';
import { icons } from './icons.ts';
import { GridItem } from './interface.ts';

import { projects } from './HistoryData.ts';

type Props = {
  onClick: (item: GridItem) => void;
};

export const History: React.FC<Props> = ({ onClick }) => {

  return (
    <div className="history">
      <div className="menu-content">
        <div className="menu">
          <Text style={{ padding: 8, paddingBottom: 0 }} variant="title3">
            {'Working History'}
          </Text>
          {projects.map((item) => (
            <div
              key={item.id}
              className={`menu-item`}
              onClick={() => onClick(item)}
            >
              <div>
                <img
                  style={{ backgroundColor: 'grey', padding: 2 }}
                  src={item.icon}
                  alt=""
                />
              </div>
              <Text style={{ width: '100%', marginRight: 8 }} variant="body">
                {item.title}
              </Text>
              <span
                className={`arrow`}
              >
                ▶
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
